/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationDTO } from './LocationDTO';
import {
    LocationDTOFromJSON,
    LocationDTOFromJSONTyped,
    LocationDTOToJSON,
} from './LocationDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface LocationPageDTO
 */
export interface LocationPageDTO {
    /**
     * 
     * @type {Array<LocationDTO>}
     * @memberof LocationPageDTO
     */
    content?: Array<LocationDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof LocationPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof LocationPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof LocationPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof LocationPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the LocationPageDTO interface.
 */
export function instanceOfLocationPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocationPageDTOFromJSON(json: any): LocationPageDTO {
    return LocationPageDTOFromJSONTyped(json, false);
}

export function LocationPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(LocationDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function LocationPageDTOToJSON(value?: LocationPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(LocationDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

